exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#word-cloud {\n  background-image: url(" + require("../public/cloud.png") + ");\n}\n\n.wc-list {\n  height: 100px;\n  overflow: scroll;\n}\n\n#wc {\n  width: 80%;\n  margin-right: 10px;\n  height: 500px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/WordCloud/style.css
// module id = 9
// module chunks = 0